import { encodeBase32UpperCaseNoPadding } from "./encoding";

export const generateNumberOnlyOtp = (size: number = 4) => {
    const characters = '0123456789';
    const bytes = new Uint8Array(size);
    crypto.getRandomValues(bytes);
    let code = '';
    for (let i = 0; i < size; i++) {
        code += characters[bytes[i]! % characters.length];
    }
    return code;
}

export const generateOTPJsOnly = (size: number = 6) => {
    const characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const bytes = new Uint8Array(size);
    crypto.getRandomValues(bytes);
    let code = '';
    for (let i = 0; i < size; i++) {
        code += characters[bytes[i]! % characters.length];
    }
    return code;
}

export function generateRandomOTP(): string {
    const bytes = new Uint8Array(5);
    crypto.getRandomValues(bytes);
    const code = encodeBase32UpperCaseNoPadding(bytes);
    return code;
}

export function generateRandomRecoveryCode(): string {
    const recoveryCodeBytes = new Uint8Array(10);
    crypto.getRandomValues(recoveryCodeBytes);
    const recoveryCode = encodeBase32UpperCaseNoPadding(recoveryCodeBytes);
    return recoveryCode;
}
